import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import IncomingCalls from './incomingcalls';
import OutgoingCalls from './outgoingcalls';
import AgentGroupsPriority from './agentgroupspriority';
import Times from './times';
import ActiveChats from './activechats';
import ButtonActions from './buttonactions';
import AgentChannels from './agentchannels';
import useMonitorAPIService from '../../services/monitorapiservice';
import AgentGroups from './agentgroups';
import AgentSocialSummary from './agentsocialsummary';
import { setShowChat, selectChat } from "src/redux/chatSlice";

function AgentsStatus(props) {

    const { t } = useTranslation();
    const { getUserGroups, getSupervisedGroups } = useMonitorAPIService();
    const [tab, setTab] = useState("calls");
    const [groups, setGroups] = useState([]);
    const [userGroups, setUserGroups] = useState([]);

    useEffect(() => {
        if (!props.agent?.userId || !props.token) return;

        getUserGroups(props.token, props.agent.userId, res => {
            setUserGroups(res.data);
            getSupervisedGroups(props.token, (res) => {
                if (res.data != null && res.data.length > 0) {
                    let grps = res.data.map(x => ({
                        label: x.groupName,
                        value: x.groupId,
                        prioridad: x.prioridad
                    }));
                    setGroups(grps);
                }
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.agent?.userId, props.token]);

    useEffect(() => {
        if (!props.functions?.currentStatus) {
            setTab("groups");
        }
    }, [props.functions]);

    const statusColors = {
        "free": "success",
        "loggedout": "secondary",
        "paused": "danger",
        "wrapup": "warning"
    };

    if (!props.agent) {
        return null;
    }

    return (
        <>
            <Row>
                <Col>
                    <div className={"d-flex align-items-center me-2 p-10"}>
                        <div className="symbol symbol-75px me-3">
                            {!props.agent.photo && (
                                <span className='user-img text-primary bg-light-primary'>
                                    {props.agent.initials || '?'}
                                </span>
                            )}

                            {props.agent.photo && (
                                <img 
                                    src={props.agent.photo} 
                                    alt="agent" 
                                    style={{ height: "50px", width: "50px" }} 
                                />
                            )}
                            <div className={
                                "position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-body h-20px w-20px bg-" + 
                                (statusColors[props.agent?.strAcdStatus?.toLowerCase()] || 'secondary')
                            }></div>
                        </div>
                        <div className="w-100">
                            <div className="fs-1 text-primary fw-bold w-100">
                                {props.agent.fullName || 'Unknown Agent'}
                            </div>
                            <div className="fs-4 text-muted fw-bold">
                                {props.agent.ext || ''}
                            </div>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className='d-flex align-items-center me-2 p-10 float-end'>
                        <ButtonActions 
                            agent={props.agent}
                            token={props.token}
                            record={props.record}
                            id={props.id}
                            functions={props.functions}
                            setShowChat={props.setShowChat}
                            selectChat={props.selectChat} 
                        />
                    </div>
                </Col>
            </Row>
            <Row className='p-5'>
                {props.functions?.currentStatus && (
                    <Col 
                        className={
                            "fs-4 pb-3 " +
                            (tab === "calls" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } 
                        onClick={e => { setTab("calls") }}
                    >
                        <FontAwesomeIcon icon={duotone('chart-simple')} /> 
                        <span className='chattab'>{t("currentstatus")}</span>
                    </Col>
                )}

                <Col 
                    className={
                        "fs-4 pb-3 " +
                        (tab === "groups" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                    } 
                    onClick={e => { setTab("groups") }}
                >
                    <FontAwesomeIcon icon={duotone('gears')} /> 
                    <span className='chattab'>{t("config")}</span>
                </Col>
            </Row>

            {tab === "calls" && (
                <>
                    <Row>
                        <Col>
                            <IncomingCalls calls={props.agent.calls || []}></IncomingCalls>
                            <OutgoingCalls calls={props.agent.calls || []}></OutgoingCalls>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <AgentSocialSummary 
                                incoming={props.agent.chatsSummary || []} 
                                outgoing={props.agent.outgoingChatsSummary || []}
                            ></AgentSocialSummary>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <ActiveChats 
                                activeChats={props.agent.activeChats || []} 
                                agent={props.agent}
                            ></ActiveChats>
                        </Col>
                        <Col>
                            <Times agent={props.agent}></Times>
                        </Col>
                    </Row>
                </>
            )}

            {tab === "groups" && (
                <>
                    <Row>
                        <Col>
                            <AgentGroupsPriority 
                                agent={props.agent} 
                                groups={userGroups} 
                                setGroups={setUserGroups}
                            ></AgentGroupsPriority>
                        </Col>
                        <Col>
                            <AgentChannels agent={props.agent}></AgentChannels>
                        </Col>
                    </Row>
                    <Row>
                        <AgentGroups 
                            agent={props.agent} 
                            groups={groups} 
                            userGroups={userGroups}
                        ></AgentGroups>
                    </Row>
                </>
            )}
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        id: state.supervisor.id,
        token: state.supervisor.token,
        notify: state.parameters.notify,
        record: state.parameters.record,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, { setShowChat, selectChat })(AgentsStatus);
